module.exports = __webpack_public_path__ + "img/weather-icon.aebf7aa0.svg";